import React from "react";
import GuidImg from "../image/guidlinesimgsign.png";
import SignImg from "../image/guidsign1.png";
import Stamp from "../image/guidstamp.png";

export default function Guidelines() {
  return (
    <div className="py-8 px-10 mx-5 space-y-6 text-justify text-sm text-gray-800 font-sans leading-relaxed">
      {/* Section A */}
      <section>
        <h2 className="font-bold text-base mb-2">
          A] Requirements before start for Inspection site from residence or
          AIPL office:
        </h2>
        <ol className="list-decimal ml-5 space-y-1">
          <li>
            To ask Operation Manager/Technical Manager/Inspection Coordinator
            for Inspection Notification (In form of mail or telephone etc.) &
            related documents received from Client or Buyer.
          </li>
          <li>
            To review & understand the requirements. In case of assistance, he
            should contact Operation Manager/Technical Manager or Senior
            Experienced Engineer from AIPL.
          </li>
          <li>
            To confirm readiness of Vendor before start of visit. This includes
            information on rules for the access and use of the specified
            facilities & Equipment necessary to perform inspections, its working
            condition and calibration status.
          </li>
          <li>
            To travelsafely& reach inspection location on time considering work
            timings of company to be visited.
          </li>
          <li>
            In case of 2 visits in a day, Inspector must calculate timings in
            co-ordination with Vendor rep. based on activities to be offered &
            accordingly inspection at another vendor to be carried out.
          </li>
        </ol>
      </section>

      {/* Section B */}
      <section>
        <h2 className="font-bold text-base mb-2">
          B] Requirements at inspection location:
        </h2>
        <ol className="list-decimal ml-5 space-y-1">
          <li>
            To give ENTRY & EXIT calls in the form text message with time
            through SMS or any messenger app as per company policy.
          </li>
          <li>
            Monthly Invoice/Time Sheet must be submitted on last day of the
            working month or 1st day of the new month by 12 pm.
          </li>
          <li>
            Flash email must be sent ‘in reply’ to the inspection call email
            before leaving the shop, in case of Continued inspection on
            following day or for an Engineer if not possible to issue inspection
            report in same day by late evening. The contents of email must be
            activities of inspections carried out in short or simple
            understandable form.
          </li>
          <li>
            Follow the procedure at inspection site with respect to Environment,
            Health and Safety requirements, refer safety instruction to AIPL
            Inspector/Surveyors.
          </li>
          <li>
            Ensure availability and use of adequate PPE at the time of
            inspection.
          </li>
          <li>
            <strong>
              Check the Calibration Certificates of all measuring/testing
              equipment/instruments for validity and ensure that Calibration is
              available at the values of point-of-use (e.g. Power meter
              calibrated at Rated Voltage Point etc. and not only for range).
            </strong>
          </li>
        </ol>
      </section>

      {/* Section C */}
      <section>
        <h2 className="font-bold text-base mb-2">
          C] Report submission deadline:
        </h2>
        <p>
          The last deadline for submitting the inspection reports will be by
          next day 12 pm. Inspector is required to also submit the scan/photo of
          the diary he has written including any calculations done for the
          inspection as applicable
        </p>
      </section>

      {/* Section D */}
      <section>
        <h2 className="font-bold text-base mb-2">
          D] Types of Reports followed by AIPL:
        </h2>
        <ol className="list-decimal ml-5 space-y-1">
          <li>
            Flash Report (FR): <br /> To prepare for everyday reporting, If
            Inspection continues for more than one day. The FR must have Areas
            of concern if any, Vendor signature and 1 copy issued to them at
            shop itself.
          </li>
          <li>
            Inspection Report (IR): <br /> It is our official Reporting format
            and to be made mentioning all details as per the Format applicable.
            Photos of Inspection shall be part of IR
          </li>
          <li>
            Inspection Release note (IRN): <br /> To be issued based on the
            completion of inspection without any open punch points in IR to our
            office/admin along with Inspection Report.
          </li>
        </ol>
      </section>

      {/* Section E */}
      <section>
        <h2 className="font-bold text-base mb-2">
          E] Report Numbering Methodology:
        </h2>
        <ul className="ml-5 space-y-1">
          <li>
            <strong> Inspection Report :</strong> AIPL IR/AAAA/BBBB/CC/X
          </li>
          <li>
            <strong> Inspection Release Note :</strong> AIPL IRN/AAAA/BBBB/CC/X
          </li>
          <li>
            <strong> Flash Report :</strong> AIPL FR/AAAA/BBBB/CC/X
          </li>
          <li>
            <strong> AAAA – </strong>Client Name in max. 4 letters
          </li>
          <li>
            <strong> BBBB – </strong>Supplier/Vendor Name in max. 4 letters
          </li>
          <li>
            <strong>CC – </strong>Reporting AIPL Engineer’s name initials in
            max. 2 letters.
          </li>
          <li>
            <strong>X – </strong>Sr. No.
          </li>
          <li>
            GIVE NAME/NUMBER TO SOFT COPY FILE OF REPORT BY REPLACING ‘/’ WITH
            ‘-‘. e.g. Inspection Report AIPL IR-AAAA-BBBB-C
          </li>
          <li>
            In some case Client Reporting numbering methodology is used. (It
            will be communicated as applicable by office/admin)
          </li>
          <li>
            In case of any query, concern Engineer shall contact Operation
            Manager/Technical Manager for clarity.
          </li>
        </ul>
      </section>
      {/* Section F */}
      <section>
        <h2 className="font-bold text-base mb-2">
          F] Mandatory Minimum things to be reported in the Inspection Report:
        </h2>
        <ol className="list-[lower-alpha] ml-5 space-y-2">
          <li>
            <strong>Item description:</strong> Client PO Sr. No, description and
            any special instructions to be reported in the remarks or notes in
            PO. Conclusion for Inspection of the Item i.e., acceptable / under
            hold / Rework and Reoffer etc. to be mentioned in ‘Remark’ Column
            for each Item.
          </li>
          <li>
            <strong>Reference documents:</strong> Client Approved Documents only
            i.e. Purchase order, Drawing, ITP, Specification, Datasheet etc.
          </li>
          <li>
            <strong>Inspection Activity:</strong>
            <ol className="list-decimal ml-5 space-y-2">
              <li>
                <strong>Scope of Visit:</strong> The activities mentioned in
                inspection call or stages covered during the visit as per ITP.
                Mention details of other persons who attended/participated in
                the Inspection.
              </li>
              <li>
                <strong>Deviations:</strong> Mention deviations noticed at
                inspection site with respect to{" "}
                <strong>Environment, Health and Safety</strong> requirements,
                refer safety instruction to AIPL Inspector/Surveyors and write
                about it at Section 2 of ‘Inspection Activity’ details in
                Inspection Visit Report Format.
                <br />
                If no abnormality is observed; PLEASE MENTION:{" "}
                <strong> NIL.</strong>
              </li>
              <li>
                <strong>Details of inspection:</strong>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Condition of Job/Inspection Item during Inspection.</li>
                  <li>
                    All observations of Inspection shall be made with reference
                    to QAP/ITP Clauses as applicable.
                  </li>
                  <li>
                    IR shall mention hard stamping done with locations of
                    stamping.
                  </li>
                  <li>
                    In case of random inspection percentage (%), Sr. No(s). / ID
                    no(s). of random selected samples shall be recorded in
                    report, while witnessed items shall be identified separately
                    and reported.
                  </li>
                  <li>
                    Attachments shall be reported in the IR such as witness &
                    review documents as applicable.
                  </li>
                </ul>
              </li>
              <li>
                <strong>
                  Detail of Measuring/Testing Equipment and Calibration:
                </strong>
                <br />
                Ensure that the measuring and Testing instruments/equipment is
                with valid Calibration Certificate traceable to national or
                international standards and in good working condition and should
                be handled safely while using it during Inspection activity.{" "}
                <br />
                Calibration details of all instruments used for Inspection shall
                be mentioned with due date of calibration.
              </li>
              <li>
                <strong>Punch List:</strong> Shall be mentioned in case of any
                discrepancy observed during inspection.
              </li>
              <li>
                <strong>Photographs:</strong> Shall be part of Inspection Report
                (Photos to be taken progressively & shall be with names). For
                example
                <img src={GuidImg} alt="Guidelines" className="my-2" />
              </li>
            </ol>
          </li>
          <li>
            All supporting documents shall be reviewed as per the clauses of
            QAP/ITP and scanned copy of the documents shall be sent to the
            office/admin and in some cases one set of hard copies needs to be
            submitted.
          </li>
          <li>
            Inspector to clearly mention about unique identification mark used
            to identify items inspected.
          </li>
          <li>Spell check shall be done before final submission of Report.</li>
          <li>
            Duly signed FR / IR / IRN with all supporting documents shall be
            emailed to office/admin.
          </li>
        </ol>
      </section>
      {/* Section G */}
      <section className="mt-6">
        <h2 className="font-bold text-base mb-2">
          G] Mandatory Minimum things to be reported in the Flash Report:
        </h2>
        <ol className="list-[lower-alpha] ml-5 space-y-2">
          <li>
            <strong>Purchase Order/Reference documents:</strong> Client Approved
            Documents only i.e Purchase order, Drawing, ITP, Specification,
            Datasheet etc.
          </li>
          <li>
            <strong>Supplier Details:</strong> Supplier Name & address, contact
            person name & contact details.
          </li>
          <li>
            <strong>Inspection Activity:</strong>
            <ol className="list-decimal ml-5 space-y-2">
              <li>
                <strong>Detail of inspection:</strong>
                <br />
                Areas of Concern if any
                <br />
                Condition of Job/Inspection Item during Inspection.
                <br />
                All observations of Inspections shall be recorded as per clauses
                of ITP.
              </li>
              <li>
                Mention deviations noticed at inspection site with respect to
                Environment, Health and Safety requirements, refer safety
                instruction to AIPL Inspector/Surveyors and write about it at
                Section 2 of ‘Inspection Activity’ details in Flash Report
                Format.
                <br />
                If no abnormality is observed;{" "}
                <strong>PLEASE MENTION: NIL</strong>
              </li>
              <li>
                <strong>Balance activities:</strong> Flash Report shall clearly
                mention balance stages of Inspection as per clauses of ITP.
              </li>
              <li>Indicate Next Date of Inspection, if planned.</li>
            </ol>
          </li>
        </ol>
      </section>
      <div className="mt-6">
        <div className="flex justify-between mt-4">
          <div>
            <p className="font-bold text-black">Prepared by</p>
            <img src={SignImg}  />
            <br />
            <p className="font-bold text-sm">Madhav Naik</p>
            <p className="font-bold text-sm">IMC</p>
          </div>
          <div>
            <p className="font-bold text-black">Approved By</p>
            <img src={Stamp}  />
            <p className="font-bold text-sm">Ramesh S Jadhav</p>
            <p className="font-bold text-sm">CEO & Managing Director </p>
          </div>
        </div>
      </div>
    </div>
  );
}
